export default __webpack_public_path__ + "static/media/search-icon.dd7c7fa7.svg";